import {
  RealizationTable,
  useGetRealizationPageQuery,
  RealizationFormPopup,
  RealizationId,
  Realization,
  useRealizationDeleteMutation,
} from "@tracabois/domain";
import { PlatformPage } from "@tracabois/template";
import { Button } from "@komune-io/g2-components";
import { realizationRoute } from "../route";
import { Row } from "@komune-io/g2-layout";
import { useTranslation } from "react-i18next";
import { useCallback, useMemo } from "react";
import { usePageQuery, usePopup } from "@tracabois/components";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import { Upload } from "@mui/icons-material";

export interface RealizationListPagePros {}

const useLabels = () => {
  const { t } = useTranslation();

  return useMemo(
    () => ({
      realizations: t("realization.plurals"),
      createRealization: t("realization.create"),
      importCsv: "Importer CSV",
    }),
    [t]
  );
};

export const RealizationListPage = (_: RealizationListPagePros) => {
  const popup = usePopup();
  const label = useLabels();
  const navigate = useNavigate();
  const pageQuery = usePageQuery(useGetRealizationPageQuery);

  const [deleteRealization] = useRealizationDeleteMutation();

  const handleImportCsv = useCallback(() => {
    navigate("/csv/import");
  }, [navigate]);

  const actions = (
    <Box sx={{ display: "flex", gap: 2 }}>
      <Button variant="outlined" startIcon={<Upload />} onClick={handleImportCsv}>
        {label.importCsv}
      </Button>
      <Button color="primary" onClick={popup.open}>
        {label.createRealization}
      </Button>
    </Box>
  );

  const clickHandler = (row: Row<Realization>) => {
    realizationRoute.goto.viewRealization(row.original.id, navigate);
  };

  const handleCreate = async (id: RealizationId) => {
    realizationRoute.goto.viewRealization(id, navigate);
  };

  const handleDelete = useCallback(
    async (id: string) => {
      try {
        await deleteRealization({ id } as any).unwrap();
      } catch (error) {
        console.error("Error deleting realization:", error);
      }
    },
    [deleteRealization]
  );

  return (
    <PlatformPage title={label.realizations}>
      <RealizationTable
        actions={actions}
        onRowClicked={clickHandler}
        page={pageQuery.data}
        isLoading={pageQuery.isLoading}
        onPageQueryChange={pageQuery.setPageQuery}
        onDelete={handleDelete}
      />
      <RealizationFormPopup
        type={"create"}
        onSaved={handleCreate}
        onClose={popup.close}
        open={popup.isOpen}
      />
    </PlatformPage>
  );
};
